import { useQuery } from "@tanstack/react-query";
import { getTargetareListe } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";
import type { TargetareListaFisier } from "@/types/targetare";

const listaInLucru = (fisiere: TargetareListaFisier[] | undefined) =>
  (fisiere ?? []).some(
    (f) =>
      f.actualizare_stare === "in_curs" || f.actualizare_stare === "programata"
  );

export function useGetTargetareListe() {
  return useQuery({
    refetchInterval: (query) =>
      listaInLucru(query.state.data?.data.fisiere) ? 8000 : false,
    queryKey: queryKeys.targetare.liste(),
    queryFn: getTargetareListe,
    select: (response) => response.data,
    staleTime: 1000 * 60 * 2,
    retry: 1,
  });
}
